import type { AxiosInstance } from "axios";
import type {
  SalesforceObjectDefinition,
  SalesforceObjectDefinitionMetadata,
} from "./SalesforceSourceSettings.types";

export class SalesforceSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getObjectDefinitions(
    boardId: string,
    connectionId: string,
  ): Promise<SalesforceObjectDefinition[]> {
    const response = await this.client.get<SalesforceObjectDefinition[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/salesforce/objectdefinitions`,
    );
    return response.data;
  }

  async getObjectDefinitionMetadata(
    boardId: string,
    connectionId: string,
    objectDefinition: SalesforceObjectDefinition,
  ): Promise<SalesforceObjectDefinitionMetadata> {
    const response = await this.client.post<SalesforceObjectDefinitionMetadata>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/salesforce/objectdefinitions`,
      objectDefinition,
    );
    return response.data;
  }
}
